import { useDispatch, useSelector } from "react-redux";

import './EditUserForm.css';

import { changeEditUserBranch, changeEditUserName, changeEditUserRole, changeStatus, clearEditUserForm, deleteUser, editUserFormIsActive, selectConfirmingUserDelete, selectConfirmingUserUpdate, selectEditUserFormBranch, selectEditUserFormName, selectEditUserFormUserId, selectEditUserFormUserRole, setConfirmingUserDelete, setConfirmingUserUpdate, toggleEditUserForm, updateUser, userDeleting, userUpdating } from "./editUserFormSlice";
import {  removeUser, updateUserInfo } from "../manageUsers/manageUsersSlice";
import { selectBranches } from "../manageBranches/branchesSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectUser } from "../home/userSlice";
import { selectToken } from "../login/loginSlice";

export default function EditUserForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const activeEditForm = useSelector(editUserFormIsActive);
    const branches = useSelector(selectBranches);
    const editFormUserId = useSelector(selectEditUserFormUserId);
    const editFormName = useSelector(selectEditUserFormName);
    const editFormUserRole = useSelector(selectEditUserFormUserRole);
    const editFormBranch = useSelector(selectEditUserFormBranch);
    const updatingUser = useSelector(userUpdating);
    const confirmingUpdate = useSelector(selectConfirmingUserUpdate);
    const deletingUser = useSelector(userDeleting);
    const confirmingDelete = useSelector(selectConfirmingUserDelete);

    const userInfo = useSelector(selectUser);
    const bankId = userInfo.bankId;

    const display = activeEditForm ? "flex" : "none";

    const handleEditUserNameChange = (event) => {
        dispatch(changeEditUserName(event.target.value));
    }

    const handleEditUserRoleChange = (event) => {
        dispatch(changeEditUserRole(event.target.value));
    }

    const handleEditUserBranchChange = (event) => {
        dispatch(changeEditUserBranch(event.target.value));
    }

    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(toggleEditUserForm());
        dispatch(clearEditUserForm());
    }

    const handleConfirmCancelClick = () => {
        dispatch(setConfirmingUserUpdate(false));
        dispatch(setConfirmingUserDelete(false));
    }

    const handleDeleteButtonClick = (event) => {
        event.preventDefault();
        dispatch(setConfirmingUserDelete(true));
    }

    const handleConfirmDeleteClick = () => {
        dispatch(deleteUser({userId: editFormUserId, token}));
        dispatch(toggleEditUserForm());
        dispatch(removeUser(editFormUserId));
        dispatch(setConfirmingUserDelete(false));
    }

    const handleUpdateUserButtonClick = (event) => {
        event.preventDefault();
        if (editFormUserRole === 'USER' && !editFormBranch) {
            dispatch(changeStatus('Student accounts must be assigned to a branch'));
        } else {
            dispatch(setConfirmingUserUpdate(true));
        }
    }

    const handleConfirmUpdateClick = () => {
        const updatedUser = {
            username: editFormUserId,
            name: editFormName,
            userRole: editFormUserRole,
            bankId: bankId,
            branchId: editFormUserRole === 'USER' ? editFormBranch : ''
        }

        dispatch(updateUser({userToUpdate: updatedUser, token}));
        dispatch(toggleEditUserForm());
        dispatch(updateUserInfo(updatedUser));
        dispatch(setConfirmingUserUpdate(false));
    } 

    return (
        <form className="form" style={{display:display, flexDirection:'column'}}>
            <h3>Edit User</h3>
            <label>
                User Id: {editFormUserId}
            </label>
            <label htmlFor="name">
                Name:
                <input value={editFormName} onChange={handleEditUserNameChange}></input>
            </label>
            <label htmlFor="userRole">
                User Role:
                <select value={editFormUserRole} onChange={handleEditUserRoleChange}>
                    <option value={'ADMIN'}>Admin</option>
                    <option value={'TELLER'}>Teller</option>
                    <option value={'USER'}>Student</option>
                </select>
            </label>
            {editFormUserRole !== 'USER' ? "" : (
                <label htmlFor='branch'>
                    Branch:
                    <select value={editFormBranch} onChange={handleEditUserBranchChange}>
                        <option key="blank" value="blank">- select -</option>
                        {branches.map(branch => <option key={branch.branchId} value={branch.branchId}>{branch.branchName}</option>)}
                    </select>
                </label>
            )}
            <div className='button-container'>
                <button onClick={handleCancelButtonClick} disabled={updatingUser || deletingUser}>Cancel</button>
                <button onClick={handleDeleteButtonClick} disabled={updatingUser || deletingUser}>{deletingUser ? "Deleting User..." : "Delete User"}</button>
                <button onClick={handleUpdateUserButtonClick} disabled={updatingUser || deletingUser}>{updatingUser ? "Updating User..." : "Update User"}</button>
            </div>
            {confirmingUpdate ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmUpdateClick}/> : ""}
            {confirmingDelete ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmDeleteClick}/> : ""}
        </form>
    )
}